module.exports = __webpack_public_path__ + "static/media/edit.addc115d.svg";